export default {"src":"https://gfiber.com/support/_next/static/media/arrow_back.f6e539cf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};